import { Component, Input, OnInit } from "@angular/core";
import { ResumeService } from "../../../resume/resume.service";
import { ActualSelected } from "../../../../shared/utils";

@Component({
    selector: 'report-working-capital',
    templateUrl: './report-working-capital.component.html',
    styleUrls: ['./report-working-capital.component.css'],
    standalone: false
})

export class ReportWorkingCapitalComponent implements OnInit {
  @Input()
  showGlobal: boolean = false;

  resumeloading = false;
  summaryResult: any;

  yearSelected: string;

  constructor(
    private resumeService: ResumeService,
  ) {
  }

  ngOnInit() {
    this.getData();
    // console.log('ActualSelected', ActualSelected)
    this.yearSelected = ActualSelected.yearSelected;
  }

  getData() {
    this.resumeloading = false;
    ActualSelected.global = this.showGlobal ? "1" : "0";

    this.resumeService.getReportWorkingCapital().then(response => {
      this.summaryResult = response;
      this.resumeloading = true;
    });
  }

  getPositivePercentage(num1, num2) {
    const ratio = num1 / num2;
    return Math.abs(ratio); // Usa Math.abs para garantizar un valor positivo
  }
}
